import React from "react"
import { SanityRichTextProcessor } from "../../../sanity/richText/provider"
import { RichTextRenderingProps } from "../../../sanity/richText/types"

export interface RichTextProps extends RichTextRenderingProps {}

export const TwRichTextField = (props: RichTextProps) => {
  return <SanityRichTextProcessor {...props} />
}
